
import React,{useState,useRef,memo,useEffect,useCallback} from 'react'
import history from 'system/navigation/MainRouterHistory'
// import {fetchCMSJSON,fetchCMSJSONs} from 'system/AssetManager'
import styles from './page.module.css'
import * as DynamicComponentMap from  './canvas/dynamic'
import Globals from '../system/Globals'
import { animEventEmitter } from "../system/utils/eventEmitter";


const Page = memo(function(props){

    let loadCount = 0
    const refPage= useRef()
    const [inline,setInline] = useState({})
    const [inlineContainer,setInlineContainer] = useState({})
    const [localPage, setLocalPage] = useState(props.model);
    const [animPage, setAnimPage] = useState(false);
    

    const [format,setFormat] = useState(null)
    const refScrollTable =useRef({})
    
    const [loaded,setLoaded] = useState(false)
    const refCallbacks=useRef(new Array(props.model.components_count))
    const refAnimFuncs=useRef(new Array(props.model.components_count))
    // const refCallbacks = useRef()
    const refInteractionListener = useRef()
    // const refElements=useRef([])
    const refParallaxElements = useRef([])
    const refThrehold = useRef(0.5)
    const refContainerScale = useRef(1)
    const [renderNumber, setRenderNumber] =useState(0)
    const refMediaContainer = useRef();
    const refLastLoadComplete = useRef(0);
    
    //initial pageState
    let ps;
    props.model.components.map((val,i) => { if(val.component==="statePNGButton" && ps===undefined) ps=val.id })
    const [pageState,setPageState] = useState(ps)

    function setScrollTable(cb,index){
        // console.log('Page setScrollTable', cb, index)
        if(cb) refScrollTable.current[index]=cb
    }

    const runLayerAnim = (newValue) => {
        console.log('newValue', newValue, props.model.id)
        console.log('refAnimFuncs.current', refAnimFuncs.current)
        if (newValue === props.model.id) {
            console.log('Running Anim', 'Functions registered:', refAnimFuncs.current ? refAnimFuncs.current.length : 0)


            refAnimFuncs.current && refAnimFuncs.current.forEach(f=>{ 
                f(true, null) 

                })
            
            // Safety: Play all autoplay videos on this page
            if (refMediaContainer.current) {
                const videos = refMediaContainer.current.querySelectorAll('video[data-auto="true"]');
                console.log('Found autoplay videos to start:', videos.length);
                videos.forEach(video => {
                    video.currentTime = 0; 
                    if (video.paused) {
                        
                        video.play().then(() => {
                            console.log('Safety autoplay started for video:', video.id);
                        }).catch(error => {
                            console.error('Safety autoplay error:', error);
                        });
                    }
                });
            }
        } else {
            // console.log('Stopping Anim')
            refAnimFuncs.current && refAnimFuncs.current.forEach(f=>{ 
                f(false, null) 

                })
        }
      };

    const handleResize = ()=>{
        let format = Globals.instance().getFormat(props.model.formats, null, window.innerWidth)
        let w= format['canvas_width']?parseFloat(format['canvas_width']):window.innerWidth
        let h= format['canvas_height']?parseFloat(format['canvas_height']):'1080'
        if(w==='100%')w=window.innerWidth
        let scale=window.innerHeight/h
        if (props.renderOnly) {
            scale = window.innerWidth / w
        }
        refContainerScale.current=scale
        setInline(props.renderOnly ? { width: w * scale + 'px', height: h * scale + 'px', margin: 'auto' } : { width: '100%' ,height:'100%' })
        let leftOffset=  format.fit==="crop"?(window.innerWidth-(w*scale))/2:0
        if(leftOffset>0)leftOffset=0
        if( !props.renderOnly && (format.fit==="fill" || format['canvas_width'] === "100%") )
        {w=window.innerWidth/scale}
        scale = Math.round(scale*1000)/1000 //round up a hair

        // console.log('scale etc', scale, format.aspect_ratio, props.model.inset, props.model.inset && props.model.inset.aspect_ratio, props.model.inset && parseFloat(props.model.inset.aspect_ratio), window.innerWidth/window.innerHeight)

        // if (props.model.inset && (parseFloat(props.model.inset.aspect_ratio).toFixed(2) === parseFloat(window.innerWidth/window.innerHeight).toFixed(2))) {
        // console.log('AR Test', props.model.inset && parseFloat(props.model.inset.aspect_ratio).toFixed(2), Globals.instance().aspect_ratio)
        let frameWidth = document.getElementById('main').offsetWidth;
        let frameHeight = document.getElementById('main').offsetHeight;
        // console.log("use inset", props.model.inset && (parseFloat(props.model.inset.aspect_ratio).toFixed(2) === parseFloat(frameWidth/frameHeight).toFixed(2)), parseFloat(frameWidth/frameHeight).toFixed(2), frameWidth)
        if (props.model.inset && (parseFloat(props.model.inset.aspect_ratio).toFixed(2) === parseFloat(frameWidth/frameHeight).toFixed(2))) {
            let scale = props.model.inset.width_ratio;
            let left =  (props.model.inset.inset_x * frameWidth) + "px";
            let top = (props.model.inset.inset_y * frameHeight) + "px";
            // console.log('inset', scale, left, top)

            setInlineContainer({transform:'scale('+scale+')', transformOrigin:'top left', 'position': 'absolute', 'left': left, 'top': top})   
        }

        setRenderNumber(renderNumber+1)
        refThrehold.current = window.innerHeight/2
        if(refThrehold.current>0.5)refThrehold.current=0.5

    }

    const handleScroll = useCallback((scrollTop,screenWidth)=>{
        // eslint-disable-next-line no-unused-vars
        for (const [key, value] of Object.entries(refScrollTable.current)) {
           value.call(this,scrollTop,refContainerScale.current,screenWidth)
        }
        
    },[refScrollTable, refContainerScale])

    // useEffect(() => {
    //     if (loaded && props) {
    //         // console.log('page loaded', props, window.location.search);
    //         let action = new URLSearchParams(window.location.search).get("action");
           
    //         if (action === "page") {
    //             // setTimeout(() => {
    //             //     onLoadComplete();
    //             // }, 300);
    //              console.log('page load action', action);
    //         }
    //     }
    // }, [loaded])
    
    useEffect(()=>{
        let elePageRef=refPage.current
        //get format

        // console.log('Globals.instance().getFormat(props.model.formats)', Globals.instance().getFormat(props.model.formats))
        setFormat(Globals.instance().getFormat(props.model.formats))
        
        handleResize()
        if(props.model.components && props.model.components.length===0){
            console.warn("page with no components added")
            onLoadComplete()
        }

        let onServerEvent=(evt)=>{
            let detail = evt.detail
            if(!detail)return
            if(detail.event==='narrative-page-state'){
                // console.log('PAGE STATE '+detail.command)
                let state = props.model.controller_states.find(m=>{return m.id===Number(detail.command)})
                // console.log(state)
                if(state)
                doChangeState(Number(detail.command))
            } 
           
        }

        // console.log('props', props.model)

            //listen to server event
            if((Globals.instance().serverApp || (props.socketPrefs && props.socketPrefs.mode === "isReceive")) && props.model.controller_states && props.model.controller_states.length){
            window.removeEventListener('server-event',onServerEvent)
            window.addEventListener('server-event',onServerEvent)
        }

        // animEventEmitter.on("valueChanged", runLayerAnim);

        return ()=>{
            window.removeEventListener('resize',handleResize)
            window.removeEventListener('server-event',onServerEvent)
            refCallbacks.current=undefined
            refAnimFuncs.current=undefined
            elePageRef.removeEventListener('intersection',refInteractionListener.current)
            setAnimPage(false)
            animEventEmitter.off("valueChanged", runLayerAnim);
        }      
           
       // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

   

    useEffect(() => {
        
        if (loaded) {

            console.log('page loaded', props.model.id, loaded)

            console.log('narrative props history', window.location.search)
   

        
            // function doSomething() {
            //     console.log('Child nodes detected!');
                
            //     console.log('all components loaded', loadCount, props.model.components.length,  props.model.components)

            //     onLoadComplete()
               
            //   }
                            
            //   const intervalId = setInterval(() => {
            //     // Check if the div has any child nodes (or use targetNode.children for element nodes only)
            //     console.log('refMediaContainer.current.childNodes.length', refMediaContainer.current.childNodes.length)
            //     if (refMediaContainer.current && refMediaContainer.current.childNodes.length > -1) {
            //       doSomething();
            //       clearInterval(intervalId); // Stop checking once the condition is met
            //     }
            //   }, 100); // Check every 100 milliseconds
            
            
        }
    }, [loaded])


    const doChangeState =  useCallback((s)=>{ 
        // console.log('set pagestate',s)
        setPageState(s)},
        
        [setPageState] )


    function onLoadComplete(){
        const currentTime = Date.now();
        const timeSinceLastCall = currentTime - refLastLoadComplete.current;
        
        // Prevent execution if called within 1 second (1000ms)
        if (timeSinceLastCall < 1000) {
            console.log('onLoadComplete throttled - called too soon', {
                pageId: props.model.id,
                timeSinceLastCall,
                remaining: 1000 - timeSinceLastCall
            });
            return;
        }
        
        // Update the last execution time
        refLastLoadComplete.current = currentTime;

        console.log('onLoadComplete', props.model.id, props.index);

        props.setScrollCallback(handleScroll,props.index)

        props.onLoad(props.index, refPage.current, refParallaxElements.current)
        
    }    function onLoadComponent(index,refer,model){
        
        // if(model && model.animation && model.animation.type==="parallax"){
            
        //     refParallaxElements.current.push({
        //         ele:refer,
        //         animations:model.animation.animations
        //     })
        // }

        loadCount+=1
        // console.log('loadCount', loadCount,  props.model.components.length, props.model.id)
    
        if(loadCount >= props.model.components.length ){
            

            setLoaded(true)
            onLoadComplete()
           console.log('setting loaded', loadCount, props.model.components.length, props.model.id) 
        
         
           
        }
        // console.log('onLoadComplete', loadCount, props.model.components.length) 

    }

    function onIntersect(func,index){
        console.log('onIntersect Page Function, Index', index)
        refCallbacks.current[index]=func
        
    }

    function onAnim(func,index){
        console.log('onAnim Page Function, Index', index)
        refAnimFuncs.current[index]=func
        
    }
    

    useEffect(() => {
      

        if (props.model.components && props.model.components.length > 0) {

            // Multiple approaches to get search params for webview compatibility
            let params;
            let action;
            let slide;
            
            try {
                // Method 1: Standard URLSearchParams
                params = new URLSearchParams(window.location.search);
                action = params.get('action');
                slide = params.get('slide');
                
                // Method 2: Fallback for webview - check full href
                if (!action && window.location.href.includes('?')) {
                    const urlParts = window.location.href.split('?');
                    if (urlParts.length > 1) {
                        params = new URLSearchParams('?' + urlParts[1]);
                        action = params.get('action');
                        slide = params.get('slide');
                    }
                }
                
                // Method 3: Manual parsing as last resort
                if (!action && window.location.href.includes('action=')) {
                    const actionMatch = window.location.href.match(/action=([^&]*)/);
                    const slideMatch = window.location.href.match(/slide=([^&]*)/);
                    action = actionMatch ? actionMatch[1] : null;
                    slide = slideMatch ? slideMatch[1] : null;
                }
                
                // Method 4: Check for hash-based params (common in webviews)
                if (!action && window.location.hash.includes('action=')) {
                    const hashParams = new URLSearchParams(window.location.hash.substring(1));
                    action = hashParams.get('action');
                    slide = hashParams.get('slide');
                }
                
                console.log('URL parsing results:', {
                    href: window.location.href,
                    search: window.location.search,
                    hash: window.location.hash,
                    action,
                    slide
                });
                
            } catch (error) {
                console.error('Error parsing URL parameters:', error);
                action = null;
                slide = null;
            }
            
            // console.log('narrative action', action)
            if (action === 'page') {
                // setCurrentPage(-1)
                setTimeout(() => {
                        // pageTransition(currentPage, 'fade')
                        runLayerAnim(parseInt(slide))
                        console.log('onScrollEvent triggered from action=page', slide)
        
                    }, 1000);
                }

       

            animEventEmitter.on("valueChanged", runLayerAnim);
            
            setLocalPage(props.model)
            // console.log('props.model.components_count', props.model.components_count, props.model.components.length)
            if (props.model.components.length === props.model.components_count) {
                // onLoadComplete()
                if (!loaded) {
                    setLoaded(true)
                    console.log('set loaded 2')
                } 
                console.log('load complete', props.model.id)

                refPage.current.removeEventListener('intersection', refInteractionListener.current);
                
                refInteractionListener.current = (evt)=>{
                    // console.log("PAGE: ON INTERSECT 2 "+ props.model.id +' '+ evt.detail.intersectionRatio + ' ' + evt.detail.isIntersecting)
                    if(evt.detail.isIntersecting && evt.detail.intersectionRatio>0){
                        props.onIntersect(props.model.id)
                        // console.log('evt.detail.isIntersecting', localPage, props.model.id)
                    }
                }
        
                refPage.current.addEventListener('intersection', refInteractionListener.current, {passive:true})
                props.setScrollCallback(handleScroll,props.index)  
                props.onLoad(props.index, refPage.current, refParallaxElements.current)
            
            }
        }
        return () => {
            animEventEmitter.off("valueChanged", runLayerAnim);
        }
    }, [props.model.components])



    function getComponent(model,i,isBkg){
       
        let Component = DynamicComponentMap[model.component]

       
        if(!Component){
            console.warn('NULL Element ignoring',model)
            loadCount+=1
            return (<div className="nullcomponent"></div>)
        }

        return Component? <Component 
        index={i} 
        pageBkg={isBkg}
        model={model} 
        key={props.index+'-'+props.id+'-'+i+'-'+props.model.components.length} 
        onLoad={onLoadComponent} 
        onIntersect={onIntersect} 
        onAnim={onAnim}
        setScrollCallback={setScrollTable}
        pageIndex={props.index} 
        pageId={props.model.id}
        theme={props.theme} 
        renderNumber={renderNumber}
        format={format}
        renderOnly={props.renderOnly}
        pageState={pageState}
        setPageState={doChangeState}
        interaction={props.interaction}
        nid={props.nid}
        flatMenuItems={props.flatMenuItems}
        onScrollToEvent={props.onScrollToEvent}
        setCurrentPage={props.setCurrentPage}
        socket={props.socket}
        socketPrefs={props.socketPrefs}
        onClickElem={props.onClickElem}
        hideWebview={props.hideWebview}
        >
        </Component>:'none'
    }

    return ( 
        <div className={`${styles.container} Page force3d`} style={inline} ref={refPage} index={props.index} slideid={localPage && localPage.id} loaded={loaded?'true':'false'} location={localPage && props.index} scroll_offset={localPage && localPage.scroll_offset?parseFloat(localPage.scroll_offset)/100:0}>

            <span className={`${styles.backgroundArt} fullscreen force3d`}>
               {
               format && localPage.components.filter(o => o.is_background === true).map((val,i)=>{
                    return getComponent(val,i,true)
                })
            }
            </span>
            <div 
                className={`force3d ${styles.mediaContainer} pageLayers ${format ? "arW_" + (localPage.default_aspect_ratio ? localPage.default_aspect_ratio : format.aspect_ratio.replace(".","")) : ""}`} 
                ref={refMediaContainer}
                style={inlineContainer} 
                >


            {
                format && localPage.components.filter(o => o.is_background !== true).map((val,i)=>{
                     return getComponent(val,i,false)
                 })
             }
            
            </div>
        </div>
    )

},(prev,next)=>{
    return prev.pageState === next.pageState && prev.hideWebview === next.hideWebview
    // return true
    // JSON.stringify(prev.inline)=== JSON.stringify(next.inline)
    // return true
})


export default Page